module.exports = __webpack_public_path__ + "img/eu-flag.8f0ecc66.png";